import React, { Component } from "react";
import Header from "./Header";
import HeaderIntro from "./HeaderIntro";
import Footer from "./Footer";
import NewsLetter from "./NewsLetter";
export class Accounting extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
        <div className="container">
          <div class="container-fluid" data-aos="fade-up">
            

            <div class="section-header">
              <h3>ACCOUNTING</h3>
              <p> ClipTax provides you with a wide range of services relating to
                Book keeping and Accounting to Accounting Firms, Entrepreneurs
                and Individuals.</p>
            </div>
           
          </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default Accounting;
